import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { translationKeys } from "../../../../../models/app-translation-keys.ts";
import { useTermsOfUseService } from "../../../../../services/ServiceHooks/termsOfUseHook.ts";
import { sharedDialog } from "../../../../Shared/Components/Dialogs/SharedDialog";
import { IFileType } from "../../../../Shared/index.ts";
import { ManageTermsOfUseDialogContent } from "./ManageTermsOfUseDialogContent.tsx";

import "./ManageTermsOfUseDialog.scss";

import { UploadFile } from "../../../../../models/classes/upload-file.class.ts";
import { possibleFileTypes } from "../../../../Shared/Models/Constants/wellKnownFileTypes.const.ts";
import { manageTermsOfUseDialogFooterActions } from "./manageTermsOfUseDialogFooterActions.ts";

export interface IManageTermsOfUseDialogState {
  termsFile: UploadFile | null;
  isUpdating: boolean;
}
export interface IManageTermsOfUseDialogProps {
  isVisible: boolean;
  onHide(success: boolean): void;
}

const ALLOWED_FILE_TYPES: IFileType[] = [possibleFileTypes.pdf];

const featureTranslationKeys = translationKeys.adminArea.termsOfUse;

export const ManageTermsOfUseDialog: FunctionComponent<IManageTermsOfUseDialogProps> = props => {
  const { t } = useTranslation();
  const termsService = useTermsOfUseService();

  useEffect(() => {
    if (!props.isVisible) {
      return;
    }

    sharedDialog.openSharedDialog({
      title: t(featureTranslationKeys.actions.update.name),
      size: "medium",
      onClose: () => props.onHide(false),
      sharedState: {
        termsFile: null,
        isUpdating: false,
      } satisfies IManageTermsOfUseDialogState,
      customContent: <ManageTermsOfUseDialogContent allowedFileTypes={ALLOWED_FILE_TYPES} />,
      footerActions: manageTermsOfUseDialogFooterActions({
        onHide: props.onHide,
        uploadTerms: async (file: File) => termsService.uploadTermsOfUse({ uploadedFile: file }),
      }),
      className: "add-terms-dialog",
      customDismissBehavior: { closeIcon: true, escape: false, outsideClick: false },
    });
  }, [props.isVisible]);

  return null;
};
